import { render, staticRenderFns } from "./WorkflowTestSuitModal.vue?vue&type=template&id=5bc28191"
import script from "./WorkflowTestSuitModal.vue?vue&type=script&lang=js"
export * from "./WorkflowTestSuitModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports